import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Context } from '../shared/services/context.service';
import { elastique } from '../model/elastique.model';

@Injectable({
  providedIn: 'root'
})
export class ElastiqueService {

  constructor(private http: HttpClient, public platform: Platform) { }

  getall(){
    return this.http.get(Context.apiUrl+'elastique/getAll');
  }
  getByid(id){
    return this.http.get<elastique[]>(Context.apiUrl+'getelastique/'+id);
  }
  addNewElastique(elastique){
    return this.http.post(Context.apiUrl+'elastique/insert', elastique);
  }
  updateElastique(id,elastique){
    return this.http.put(Context.apiUrl+'elastique/update/'+id,elastique);
  }
}
